/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Method for invoking a callback asynchronously.
 */
import * as promiseimpl from './promise_external';
/**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */
export function async(f) {
 return function () {
 var argsToForward = [];
 for (var _i = 0; _i < arguments.length; _i++) {
 argsToForward[_i] = arguments[_i];
 }
 promiseimpl.resolve(true).then(function () {
 f.apply(null, argsToForward);
 });
 };
}

//# sourceMappingURL=async.js.map



//////////////////
// WEBPACK FOOTER
// ../storage/dist/esm/src/implementation/async.js
// module id = null
// module chunks = 